import { head, isObject } from 'lodash-es';

/**
 *
 * @param response
 * @return {?string[]}
 */
export function getValidationMessages(response) {
    // Check we can see which fields failed
    if (!isObject(response) || !isObject(response.fields)) {
        return;
    }

    return formatValidationMessages(response.fields);
}

/**
 * @param fields
 * @return {?string[]}
 */
export function formatValidationMessages(fields) {
    if (!fields) {
        return undefined;
    }

    return Object.keys(fields)
        .map(key => head(fields[key]))
        .filter(Boolean);
}
